import itinerariesSlice from './reducer'

export default itinerariesSlice.reducer
